import { defineStore } from 'pinia';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { updateTestFetch, createTestFetch, deleteTestFetch, duplicateTestFetch, getTestFetch, getAllTestsFetch, createExamFetch, checkSessionFetch } from '@services/testService';
import { useToast } from 'primevue/usetoast';
import { useI18n } from 'vue-i18n';

export const useTestsStore = defineStore('testsStore', () => {
    const { t } = useI18n({ useScope: 'global' });
    const toast = useToast();
    const router = useRouter();
    const currentId = ref(null);

    const allTests = ref([]);
    const main = ref({});

    const getTest = async (id) => {
        const data = await getTestFetch(id);

        currentId.value = id;
        main.value = { ...data, id };
    };

    const updateTest = async () => {
        try {
            await updateTestFetch({
                ...main.value,
            });

            toast.add({ severity: 'success', summary: t('form.changes_saved'), life: 3000 });
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    const deleteTest = async (id) => {
        try {
            const data = await deleteTestFetch(id);

            if (data === 'Success') {
                toast.add({ severity: 'success', summary: t('form.changes_saved'), life: 3000 });
                allTests.value = allTests.value.filter((test) => test.id !== id);
            }
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    const duplicateTest = async (test) => {
        try {
            const data = await duplicateTestFetch(test.id);
            allTests.value.push({ ...test, id: data });
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    const createTest = async () => {
        const id = await createTestFetch();
        router.push(`/tests/${id}/main`);
    };

    const getAllTests = async () => {
        allTests.value = await getAllTestsFetch();
    };

    const createExamId = async (language) => {
        try {
            return await createExamFetch({ id: main.value.id, language });
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    const checkSession = async (id) => {
        try {
            return await checkSessionFetch(id);
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    return { allTests, main, getTest, updateTest, createTest, getAllTests, duplicateTest, deleteTest, createExamId, currentId, checkSession };
});
